/* eslint-disable prettier/prettier */
// PLACE ALL GLOBAL TRACKING EVENTS HERE
// PLEASE ORDER BASED ON LENGTH OF LINE FOR QUICKER SEARCHING (SHORTER LINES FIRST)

export const GLOBAL_NAV_DROPDOWN = 'global_nav_dropdown'
export const GLOBAL_NATIVE_APP_QR_MODAL = 'global_native_app_qr_modal'
export const GLOBAL_DOWNLOAD_NATIVE_APP_PAGE = 'global_download_native_app_page'
